import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

import MemberSummary from './MemberSummary';

const CoMainSummary = ({ list }) => {
  return (
    <Container>
      {list.map(({ label, cnt, unit, title }, idx) => (
        <MemberSummary label={label} cnt={cnt} unit={unit} title={title} key={idx} />
      ))}
    </Container>
  );
};

export default CoMainSummary;

CoMainSummary.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
};

const Container = styled(FlexBoxColumn)`
  width: 542px;
  height: 218px;

  // justify-content: space-between;

  padding: 0 20px;
  border: 1px solid #6c60ff;
  box-shadow: 0 6px 20px rgba(200, 202, 212, 0.5);
  border-radius: 6px;
  background: #ffffff;
`;
